import React, { useState } from 'react';

import useApi from 'api';
import { BackendEnums } from 'api/codegen';
import { allLanguagesLocalised, supportedLanguages } from 'stores/constants';
import { useAsyncFunction } from 'stores/hooks';
import Button from 'ui-brand/components/Button';
import TextInput from 'ui-brand/components/TextInput';

type Props = {
  onCreate: (companyId: UUIDField) => void;
};

function CreateCompany({ onCreate }: Props) {
  const api = useApi();
  const [name, setName] = useState('');
  const [language, setLanguage] = useState<Lang>('cs');

  const [handleCreateCompany, isLoading] = useAsyncFunction(async () => {
    const createdCompany = await api.CompanyCreateCompanyApi.create({
      request: { name: { [language]: name }, language: language as BackendEnums.UserLanguageEnum },
    });
    onCreate(createdCompany.id);
  });

  return (
    <form
      className="flex flex-col gap-5"
      onSubmit={(event) => {
        event.preventDefault();
        handleCreateCompany();
      }}
    >
      <TextInput
        label={pgettext('company', 'Account name')}
        required
        autoFocus
        name="account-name"
        autoComplete="organization"
        value={name}
        onChange={setName}
      />
      <fieldset>
        <legend className="mb-2 text-base font-semibold text-retino-darkviolet sm:text-sm">
          {gettext('Company language')}
        </legend>
        <div className="flex flex-wrap gap-4">
          {supportedLanguages.map((lang) => (
            <label key={lang} className="flex items-center gap-2 text-sm text-retino-darkviolet">
              <input
                type="radio"
                name="language"
                checked={language === lang}
                onChange={() => setLanguage(lang)}
                className="accent-retino-darkviolet"
              />
              {allLanguagesLocalised[lang]}
            </label>
          ))}
        </div>
      </fieldset>
      <Button type="submit" variant="primary" fullWidth loading={isLoading}>
        {gettext('Create account')}
      </Button>
    </form>
  );
}

export default CreateCompany;
